import { render, staticRenderFns } from "./page1.vue?vue&type=template&id=88a95dbe&scoped=true&"
import script from "./page1.vue?vue&type=script&lang=js&"
export * from "./page1.vue?vue&type=script&lang=js&"
import style0 from "./page1.vue?vue&type=style&index=0&id=88a95dbe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88a95dbe",
  null
  
)

export default component.exports